import authService from "@/services/authService";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import md5 from "js-md5";
import configMixin from "@/mixin/config";
import Header from "@/components/Header";
import Banner from "@/components/Banner";

export default {
  name: "setPassword",
  components: {
    BaseComponent,
    Header,
    Banner,
  },
  mixins: [configMixin],
  data() {
    return {
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      tenantId: common.tenantId,
      backUrl: common.backUrl,
      token: common.token,
      codeInfo: "",
      password: "",
      confirmPassword: "",
      passwordErrorMsg: "",
      confirmPasswordErrorMsg: "",
      isShowPage: false,
      isSubmitting: false,
    };
  },
  methods: {
    load() {
      let self = this;
      self.codeInfo = common.getToken();
      if (!self.token && !self.codeInfo) {
        //如果没有token 并且没有验证码跳回验证码页面
        common.routerPush(self, "retrievePassword");
      }
      if (self.token) {
        //根据token获取是否存在
        let params = {
          schemaId: self.schemaId, //int 体系Id（选填）
          memberSchemaId: self.memberSchemaId,
          memberFormId: self.memberFormId, //表单id
          unique: "", //string 唯一标识。可能是用户名，邮箱，手机等;记录住密码的传 cookie
          token: self.token, //string 第三方登录传 token，token时不需要密码或是动态验证码 ;
          password: "", //string 密码。账号密码的形式必传此项。
          checkCode: "", //string 动态验证码。手机或邮箱动态验证登录传此项
          loginType: "", //string 登录方式（选填。主要是用于标识用户名，邮箱，手机等.其他标识方式必填）
          isFindPassword: 1,
        };
        return authService.login(params).then(
          (data) => {
            if (data.result == 0) {
              window.$sk.loading.hide();
              if (data.content.sess) {
                //登录成功
                if (data.content.isPwd == 0) {
                  common.routerPush(self, "noPassword");
                }
                self.isShowPage = true;
              } else {
                switch (data.content.status) {
                  case "unfound":
                    common.removeTokenPush("passwordTip", 1);
                    break;
                  case "auditing":
                    common.removeTokenPush("passwordTip", 3);
                    break;
                  case "disabled":
                    common.removeTokenPush("passwordTip", 4);
                    break;
                }
              }
            }
          },
          () => {
            //验证失败
            common.removeTokenPush("passwordTip", 1);
            //跳转
            // common.routerPush(self, "passwordTip", { type: 1});
            // window.$sk.goto("passwordtip.html" + window.location.search + "&type=1");
          }
        );
      } else {
        self.isShowPage = true;
      }
      window.$sk.loading.hide();
    },
    onSubmit() {
      let self = this;
      let isValid = true;
      self.passwordErrorMsg = self.password
        ? self.passwordErrorMsg
        : "请输入新密码";
      if (self.password != self.confirmPassword)
        return (self.confirmPasswordErrorMsg = "两次输入的密码不匹配");
      if (self.passwordErrorMsg || self.confirmPasswordErrorMsg) {
        return (isValid = false);
      }
      if (isValid) {
        self.isSubmitting = true;
        let params = {
          token: self.token || self.codeInfo, //新接口，验证码正确时返回的token令牌，不传值则使用checkCode
          memberSchemaId: self.memberSchemaId,
          memberFormId: self.memberFormId,
          password: md5(self.password).toUpperCase(),
          url: window.location.href,
          globalUserId: common.globalUserId,
          referenceUrl:
            window.navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
            "micromessenger"
              ? "微信"
              : document.referrer,
        };
        authService.forgetPwd(params).then(
          (data) => {
            self.afterSubmitHandler(data);
          },
          (data) => {
            self.afterSubmitHandler(data);
          }
        );
      }
    },
    afterSubmitHandler(data) {
      this.isSubmitting = false;
      if (data.result == 0) {
        common.removeToken(); //清除cookie
        common.removeSession();
        if (this.backUrl) {
          common.handBackUrl(this.backUrl); //跳转返回地址
        } else {
          common.routerPush(this, "login");
        }
      } else {
        window.$sk.tips.show(data["desc"]);
      }
      // this.isSubmitting = false;
    },
    passwordChange() {
      this.passwordErrorMsg =
        this.password.length < 6 || this.password.length > 20
          ? "请输入6~20个字符"
          : "";
    },
    confirmPasswordChange() {
      this.confirmPasswordErrorMsg =
        this.confirmPassword.length < 6 || this.confirmPassword.length > 20
          ? "请输入6~20个字符"
          : "";
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      this.load();
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {},
  beforeDestroy() {
    this.sk.unsubscribe();
    window.removeEventListener(
      "popstate",
      () => {
        common.removeToken();
      },
      false
    );
  },
};
